var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownToLineRegular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1078_18394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.375 16.9871H3.97917C3.49034 16.9871 3.09375 17.3723 3.09375 17.8471C3.09375 18.3513 3.49034 18.738 3.97917 18.738H16.375C16.8638 18.738 17.2604 18.3527 17.2604 17.8779C17.2604 17.4024 16.8657 16.9871 16.375 16.9871ZM14.2537 8.98771L11.0625 12.282V3.55932C11.0625 3.08165 10.6678 2.69637 10.1771 2.69637C9.68642 2.69637 9.29167 3.08165 9.29167 3.55646V12.2791L6.09937 8.98771C5.92524 8.80509 5.69023 8.71557 5.45486 8.71557C5.23697 8.71557 5.01916 8.79284 4.84835 8.94961C4.49212 9.27434 4.475 9.81865 4.81031 10.1645L9.53254 15.0379C9.86686 15.385 10.4873 15.385 10.8216 15.0379L15.5438 10.1645C15.8793 9.81854 15.862 9.27438 15.5057 8.94961C15.1502 8.62247 14.5894 8.60815 14.2537 8.98771Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1078_18394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.1667,
    height: 18.3333,
    fill: "white",
    transform: "translate(3.09375 1.55054)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownToLineRegular);
export default __webpack_public_path__ + "static/media/arrow-down-to-line-regular.f30cc809de23547859aec63a94d2ee0e.svg";
export { ForwardRef as ReactComponent };